module.exports = __webpack_public_path__ + "static/media/baseMeme9.fb30b3db.jpg";